import { Box, Center, Divider, Grid, Heading, HStack, Image, Modal, ModalContent, ModalOverlay, Spinner, Tag, Text } from "@chakra-ui/react";
import LabeledText from "components/Moleculas/LabeledText";
import { Cpf } from "models/domain/cpf.domain";
import { PhoneNumber } from "models/domain/phoneNumber.domain";
import { ComplaintStatus } from "store/modules/complaints/types";

type ComplaintDetailTemplateProps = {
    loading: boolean;
    protocol: string;
    title: string;
    description: string;
    photo: string;
    complaintType: string;
    status: ComplaintStatus;
    createdDate: Date;
    userInformation: {
        name: string,
        cpf: string,
        email: string,
        phoneNumber: string,
        address: string
    },
    messages: React.ReactNode;
    map: React.ReactNode;
    isOpenModal?: boolean;
    onCloseModal?: () => void | Promise<void>;
}

const ComplaintDetailTemplate = ({
    loading,
    map,
    photo,
    protocol,
    complaintType,
    status,
    createdDate,
    title,
    description,
    messages,
    userInformation,
    isOpenModal,
    onCloseModal
}: ComplaintDetailTemplateProps) => {
    return (
        <Modal
            isOpen={isOpenModal ?? false}
            onClose={() => onCloseModal?.()}
            onEsc={onCloseModal}
            onOverlayClick={onCloseModal}
            size="2xl"
        >
            <ModalOverlay />
            <ModalContent overflow="hidden">
                {loading && (
                    <Center p={5}>
                        <Spinner />
                    </Center>
                )}
                {!loading && map}
                {!loading && (
                    <>
                        <HStack wrap="wrap" p={5}>
                            <Image src={photo} alt={`Imagem sobre ${title}`} boxSize={24} />
                            <Box>
                                <Heading size="md">{title}</Heading>
                                <HStack alignItems="center">
                                    <Text size="sm">Protocolo: {protocol}</Text>
                                    <span>•</span>
                                    <Text size="sm">{complaintType}</Text>
                                    <span>•</span>
                                    <Tag colorScheme={status === "Não atendida" ? "orange" : "blue"}>
                                        {status}
                                    </Tag>
                                </HStack>
                                <Text color="gray.500" fontSize="sm">Criado em {createdDate.toLocaleDateString('pt-BR')}</Text>
                            </Box>
                        </HStack>
                        <Box px={5} py={3}>
                            <Text>{description}</Text>
                        </Box>
                        <Box px={5}>
                            <Text fontWeight="bold" fontSize="sm">Informações do usuário</Text>
                            <Grid gridTemplateColumns={["repeat(2, minmax(150px, 1fr))", "repeat(3, minmax(150px, 1fr))"]} gap={4}>
                                <LabeledText label="Nome" text={userInformation.name} />
                                <LabeledText label="CPF" text={Cpf.fromString(userInformation.cpf).getWithMask()} />
                                <LabeledText label="E-mail" text={userInformation.email} />
                                <LabeledText label="Telefone" text={PhoneNumber.fromString(userInformation.phoneNumber).getWithMask()} />
                                <LabeledText label="Endereço" text={userInformation.address} />
                            </Grid>
                        </Box>
                        <Divider py={2} />
                        <Box p={5}>
                            <Text fontWeight="bold" fontSize="sm">Histórico de mensagens</Text>
                            {messages}
                        </Box>
                    </>
                )}
            </ModalContent>
        </Modal>
    )
}
export default ComplaintDetailTemplate